import React, { PropsWithChildren, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CodelistPrefix, removePrefix } from 'shared/ncts/common/classifier-util'
import TransitPreviewDocumentFilesSection from './TransitPreviewDocumentFilesSection'
import { Document } from '../../document/models/types'

export interface TransitPreviewDocumentSectionProps {
  document: Document
  documentTypePrefix: CodelistPrefix
}

function TransitPreviewDocumentSection({
  document,
  documentTypePrefix,
  children,
}: PropsWithChildren<TransitPreviewDocumentSectionProps>) {
  const {
    id,
    sequenceNumber,
    documentType,
    referenceNumber,
    files,
  } = document
  const { t } = useTranslation()
  const [isDocumentRowOpen, toggleDocumentRowOpen] = useState<boolean>(false)

  return (
    <div className="transit-sidebar__document-section">
      <button
        type="button"
        className="heading w-100 mb-2 d-flex align-items-center border-bottom"
        data-bs-toggle="collapse"
        data-bs-target={`#${id}`}
        aria-expanded={isDocumentRowOpen}
        aria-controls={`${id}`}
        onClick={() => toggleDocumentRowOpen(!isDocumentRowOpen)}
      >
        <small className="document-row-content d-flex align-items-center text-start">
          <span className="document-sequence flex-shrink-0">
            <span>{t('declaration.p5.sequenceNumber')}</span>
            <span className="px-1">
              {(sequenceNumber ?? 0) + 1}
            </span>
          </span>
          <span className="document-reference pe-1" title={referenceNumber}>
            {referenceNumber}
          </span>
          <span className="document-files pe-2 flex-shrink-0">
            <i className="me-1 fal fa-file" />
            {files.length}
          </span>
          <span className="document-type px-1 flex-shrink-0">
            {removePrefix(documentType, documentTypePrefix)}
          </span>
        </small>
        <i className={`mx-2 fa ${isDocumentRowOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" />
      </button>
      <div className={`collapse ${isDocumentRowOpen ? 'show mb-3' : ''}`} id={`${id}`}>
        <div className="d-flex flex-wrap">
          {
            isDocumentRowOpen && (
              children
            )
          }
          {
            isDocumentRowOpen && (
              <TransitPreviewDocumentFilesSection files={files} />
            )
          }
        </div>
      </div>
    </div>
  )
}

export default TransitPreviewDocumentSection
